import * as React from 'react';
import * as styles from './styles.css';

import { UIHeading2, UIHeading4, UIText1, UIText2, Button, Responsive } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';

import bgDesktop from './assets/rate-suburban-bg.png';
import bgMobile from './assets/rate-suburban-bg-mobile.svg';

interface IRateSuburbanProps {
  isDesktop: boolean;
  onClick(): void;
}

export const RateSuburban: React.FC<IRateSuburbanProps> = ({ isDesktop, onClick }) => {
  return (
    <div data-testid="RateSuburban" className={styles['container']}>
      <div className={styles['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading2} ElseComponent={UIHeading4}>
          Оцените свой дом, дачу или участок
        </ConditionalWrapper>
      </div>
      <div className={styles['description']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={UIText1} ElseComponent={UIText2}>
          Будьте в курсе, сколько стоит ваша загородная недвижимость, чтобы не упустить момент для выгодной сделки
        </ConditionalWrapper>
      </div>
      <Button theme="fill_primary" size="L" onClick={onClick}>
        Узнать стоимость
      </Button>
      <Responsive desktop>
        <img className={styles['bg-desktop']} src={bgDesktop} />
      </Responsive>
      <Responsive phone tablet>
        <img className={styles['bg-mobile']} src={bgMobile} />
      </Responsive>
    </div>
  );
};

RateSuburban.displayName = 'RateSuburban';
